import React, { Dispatch, MutableRefObject, SetStateAction, useContext } from "react";
import { createContext } from "react";

import { ZoomMode } from "../../../types/zoom_mode";
import { RangeMode } from "../bookings_view/bookings_view";
import { useCalendar } from "./use_calendar";
import { Day, Month, Week } from "./use_calendar_days";

export type CalendarContextType = {
  calendarRef: (element: HTMLDivElement) => void;
  calendarScrollWrapperRef: MutableRefObject<HTMLDivElement | null>;
  calendarHeaderRef: MutableRefObject<HTMLDivElement | null>;
  dayWidth: number;
  zoomMode: ZoomMode;
  rangeMode: RangeMode;
  setRangeMode: Dispatch<SetStateAction<RangeMode>>;
  days: Day[];
  weeks: Week[];
  months: Month[];
};

const CalendarContext = createContext<CalendarContextType>({} as CalendarContextType);

type CalendarContextProviderProps = React.PropsWithChildren<{
  rangeMode: RangeMode;
}>;

export const CalendarContextProvider = ({ children }: CalendarContextProviderProps): JSX.Element => {
  const calendarValue = useCalendar();
  return <CalendarContext.Provider value={calendarValue}>{children}</CalendarContext.Provider>;
};

export const useCalendarContext = () => {
  const context = useContext(CalendarContext);
  if (context === undefined) {
    throw new Error("useCalendarContext must be used within a CalendarContextProvider");
  }
  return context;
};
